import { useCallback, useRef, useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Agent from "../../Network/Agent";
import { RMS_STATUS_FETCH_START } from "../../Reducer/RmsStatusSlice";
import RmsStatusFilter from "./RmsStatusFilter";
import { toast } from "react-hot-toast";


export default function RmsStatus() {
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();
    const [page, setPage] = useState(1);
    const selector = useSelector((state) => state.rmsStatusReducer);
    const [site_id, setSiteId] = useState('');
    const [tenant_id, setTenantId] = useState('');
    const [exporting, setExporting] = useState(false);

    const array_data = useRef({
        page: 1,
        site_id: "",
        tenant_id: "",
        cluster: "",
        zone: "",
        filter_type: "",
        lodeMore: false,
    });

    useEffect(() => {
        dispatch(RMS_STATUS_FETCH_START())

        array_data.current.site_id = site_id;
        array_data.current.page = page;
        if (page != 1) {
             array_data.current.lodeMore = true;
        }

        Agent.All_RMS_STATUS.all(dispatch, array_data.current)

    }, [page, site_id, tenant_id]);

    const searchSite = (site_code) => {
        setPage(1)
        setSiteId(site_code);
    }


    const syncData = () => {
        dispatch(RMS_STATUS_FETCH_START())
        Agent.All_RMS_STATUS.all(dispatch, array_data.current);
    }

    const callbackSearch = (form_data) => {
        array_data.current.site_id = form_data.site_id;
        array_data.current.cluster = form_data.cluster;
        array_data.current.zone = form_data.zone;
        array_data.current.filter_type = form_data.filter_type;
        array_data.current.page = form_data.page;
        array_data.current.lodeMore = false;
        array_data.current.tenant_id = form_data.tenant_id;
    }

    const exportCsv = () => {
        if (exporting) return;
        setExporting(true);
        const toastId = toast.loading("Exporting CSV...");
        Agent.All_RMS_STATUS.export(array_data.current)
            .then((response) => {
                const blob = new Blob([response.data], { type: "text/csv;charset=utf-8;" });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "rms_stations.csv");
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
                toast.success("CSV downloaded", { id: toastId });
            })
            .catch(() => toast.error("Export failed", { id: toastId }))
            .finally(() => setExporting(false));
    };



    const observer = useRef();
    const lastElementRef = useCallback((element) => {
        //element is the react element being referenced

        // disconnect observer set on previous last element
        if (observer.current) observer.current.disconnect();

        // if there's no more data to be fetched, don't set new observer
        if (!selector?.data.has_more_page) return;

        // set new observer
        observer.current = new IntersectionObserver((entries) => {
            // increase page number when element enters (is intersecting with) viewport.
            // This triggers the pagination hook to fetch more items in the new page
            if (entries[0].isIntersecting && selector?.data.has_more_page) setPage((prev) => prev + 1);
        });

        // observe/monitor last element
        if (element) observer.current.observe(element);
    }, [selector?.data.has_more_page]);


    const strAscending = selector?.sites.length > 0 && [...selector?.sites].sort((a, b) =>
        a.site_id > b.site_id ? 1 : -1,
    );

    return (
        <>



            <div className="row ms-1 me-1">

                <div className="card col-md-12">
                    <div className="card-header">
                        <div className="d-flex justify-content-between">
                            <h5>All RMS  {selector?.loading ? (
                                <span
                                    className="spinner-border spinner-border-sm ml-5 ms-2"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                            ) : (
                                <span></span>
                            )}

                            </h5>
                            <div>
                                <div class="input-group input-group-sm"><span class="input-icon-addon"><i class="fa fa-search"></i></span>
                                    <input type="text" class="form-control" placeholder="Search site id.." onChange={(e) => searchSite(e.target.value)} />
                                    <RmsStatusFilter callbackSearch={callbackSearch} />
                                    <button type="button" className="input-group-text" onClick={() => syncData()}><i className="fa-solid fa-sync me-2"></i> Sync </button>
                                    <button type="button" className="input-group-text" onClick={exportCsv} disabled={exporting}>
                                        <i className={`fa-solid ${exporting ? "fa-spinner fa-spin" : "fa-file-export"} me-2`}></i>
                                        {exporting ? "Exporting..." : "Export"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-body p-0">
                        <div className="table-responsive scrol-table-height mt-1" >

                            <table className="table thead-light rms_table table-bordered bg-white table-striped m-0 text-center">
                                <thead className="text-uppercase">
                                    <tr>
                                        <th className=" w-120">Last Updated</th>

                                        <th className="text-center " >Site ID</th>
                                        <th className="text-center " >Tenant Site ID</th>
                                        <th className="text-center " >Tenant Name</th>


                                        <th className="text-center " >Network</th>

                                        <th className="text-center  w-50">Energy Type</th>
                                        <th className="text-center  w-50">DC(V)</th>
                                        <th className="text-center  w-50">DC(A)</th>
                                        <th className="text-center  w-50">DC(kW)</th>
                                        <th className="text-center  w-50">Total Load(W)</th>
                                        <th className="text-center  w-50">Room Temp</th>
                                        <th className="text-center  w-50">Power Source</th>
                                        <th className="text-center  w-50">Battery Soc</th>
                                        <th className="text-center  w-50">Door Open</th>
                                        <th className="text-center  w-50">Mains Fail</th>
                                        <th className="text-center  w-50" >DC Low</th>
                                        <th className="text-center  w-50">Site Down</th>
                                        <th className="text-center  w-50" >Module Fault</th>
                                        <th className="text-center  w-50">LLVD</th>
                                        <th className="text-center  w-50">PG ON</th>
                                        <th className="text-center  w-50">MDB Fault</th>
                                        <th className="text-center  w-50">ODC TEMP</th>
                                        <th className="text-center  w-50">FAN FAULT</th>
                                        <th className="text-center  w-50">SMOKE</th>
                                        <th className="text-center  w-50">WATER LEAKAGE</th>
                                        <th className="text-center  w-50">AVIATION LIGHT</th>
                                        <th className="text-center  w-50">FUSE FAULT</th>
                                        <th className="text-center  w-50">PHASE FAULT</th>

                                        <th className="text-center  w-50">Overload</th>


                                    </tr>
                                </thead>
                                <tbody>
                                    {selector?.sites.length > 0 && strAscending?.map((site, index) => (
                                        <tr className={`${site.device_live_status == 0 ? 'offline-tr' : ''}`} ref={index === selector?.sites.length - 1 ? lastElementRef : undefined}>
                                            <td className="">
                                                <p className="m-0 p-0" style={{ fontSize: '12px', width: '120px' }}>{site.device_time}</p>

                                            </td>

                                            <td className="text-center">
                                                <p className="m-0 p-0" style={{ fontSize: '12px', width: '100px' }}> <Link className="fw-bold" to={`/site/${site.site_id}`}>{site.site_id}</Link></p>
                                            </td>
                                            <td className="text-center">
                                                <p className="m-0 p-0" style={{ fontSize: '12px', width: '100px' }}> <Link className="fw-bold" to={`/site/${site.site_id}`}>{site.tenant_site_id}</Link></p>
                                            </td>
                                            <td className="text-center">
                                                <p className="m-0 p-0" style={{ fontSize: '12px', width: '100px' }}> <Link className="fw-bold" to={`/site/${site.site_id}`}>{site.tenant_name}</Link></p>
                                            </td>

                                            <td className="text-center">
                                                {site.device_live_status === 1 ?
                                                    <div className="signal-bars mt1 sizing-box good four-bars">
                                                        <span>
                                                            <img src="/assets/icon/6.svg" className="tower-height" alt="" />
                                                        </span>
                                                        <div className={`first-bar bar ${site.network_val >= 1 ? '' : 'null-color'}`}>
                                                        </div>
                                                        <div className={`second-bar bar ${site.network_val >= 2 ? '' : 'null-color'}`}>
                                                        </div>
                                                        <div className={`third-bar bar ${site.network_val >= 3 ? '' : 'null-color'}`}>
                                                        </div>
                                                        <div className={`fourth-bar bar ${site.network_val >= 4 ? '' : 'null-color'}`}>
                                                        </div>
                                                        <div className={`fifth-bar bar ${site.network_val >= 5 ? '' : 'null-color'}`}>
                                                        </div>
                                                    </div>
                                                    :
                                                    <i class="fa-solid fa-wifi-slash offline-rms-icon" title="Site not updating" />
                                                }
                                            </td>
                                            <td>-</td>
                                            <td className="text-dark fw-bold">{site?.total_voltage}</td>
                                            <td className="text-dark fw-bold">{site?.total_current}</td>
                                            <td className={`${site?.max_load < site?.total_load ? 'text-danger' : 'text-dark'} fw-bold`}>{site?.kw}</td>
                                            <td className={`${site?.max_load < site?.total_load ? 'text-danger' : 'text-dark'} fw-bold`}>{site?.total_load}</td>
                                            <td className="text-dark fw-bold">{site?.temperature}</td>
                                            <td className="fw-bold">Grid</td>
                                            <td>0</td>
                                            <td>
                                                {site?.conf_door_open == 0 ? <img src="/img/gray.png" alt="" className="rms-img-size offline-tr" title="Not Configure" /> : site?.door_open == 1 ?
                                                    // <div className="alarm_icon   A3">&nbsp;</div>
                                                    <div className="alarm_icon   A3">&nbsp;</div>
                                                    :
                                                    <div className="alarm_icon   A1">&nbsp;</div>
                                                }
                                            </td>
                                            <td>
                                                {site?.mains_fail == 1 ?
                                                    <div className="alarm_icon   A3">&nbsp;</div>
                                                    :
                                                    <div className="alarm_icon   A1">&nbsp;</div>
                                                }
                                            </td>
                                            <td>
                                                {site?.dc_low == 1 ?
                                                    <div className="alarm_icon   A3">&nbsp;</div>
                                                    :
                                                    <div className="alarm_icon   A1">&nbsp;</div>
                                                }
                                            </td>

                                              <td>
                                                {site?.is_load_disconnect == 1 ?
                                                    <div className="alarm_icon   A3">&nbsp;</div>
                                                    :
                                                    <div className="alarm_icon   A1">&nbsp;</div>
                                                }
                                            </td>

                                            <td>
                                                {site?.conf_rectifier_fault == 0 ? <img src="/img/gray.png" alt="" className="rms-img-size offline-tr" title="Not Configure" /> : site?.rectifier_fault == 1 ?
                                                    <div className="alarm_icon   A3">&nbsp;</div>
                                                    :
                                                    <div className="alarm_icon   A1">&nbsp;</div>
                                                }
                                            </td>
                                            <td>
                                                {site?.conf_llvd == 0 ? <img src="/img/gray.png" alt="" className="rms-img-size offline-tr" title="Not Configure" /> : site?.llvd == 1 ?
                                                    <div className="alarm_icon   A3">&nbsp;</div>
                                                    :
                                                    <div className="alarm_icon   A1">&nbsp;</div>
                                                }
                                            </td>
                                            <td>
                                                {site?.conf_pg_status == 0 ? <img src="/img/gray.png" alt="" className="rms-img-size offline-tr" title="Not Configure" /> : site?.pg_status == 1 ?
                                                    <div className="alarm_icon   A3">&nbsp;</div>
                                                    :
                                                    <div className="alarm_icon   A1">&nbsp;</div>
                                                }
                                            </td>

                                            <td>
                                                {site?.mdb_fault == 1 ?
                                                    <div className="alarm_icon   A3">&nbsp;</div>
                                                    :
                                                    <div className="alarm_icon   A1">&nbsp;</div>
                                                }
                                            </td>
                                            <td>
                                                {site?.conf_odc_temp_high == 0 ? <img src="/img/gray.png" alt="" className="rms-img-size offline-tr" title="Not Configure" /> : site?.odc_temp_high == 1 ?
                                                    <div className="alarm_icon   A3">&nbsp;</div>
                                                    :
                                                    <div className="alarm_icon   A1">&nbsp;</div>
                                                }
                                            </td>
                                            <td>
                                                {site?.conf_dc_fan_fault == 0 ? <img src="/img/gray.png" alt="" className="rms-img-size offline-tr" title="Not Configure" /> : site?.dc_fan_fault == 1 ?
                                                    <div className="alarm_icon   A3">&nbsp;</div>
                                                    :
                                                    <div className="alarm_icon   A1">&nbsp;</div>
                                                }
                                            </td>
                                            <td>
                                                {site?.conf_smoke == 0 ? <img src="/img/gray.png" alt="" className="rms-img-size offline-tr" title="Not Configure" /> : site?.smoke == 1 ?
                                                    <div className="alarm_icon   A3">&nbsp;</div>
                                                    :
                                                    <div className="alarm_icon   A1">&nbsp;</div>
                                                }
                                            </td>
                                            <td>
                                                {site?.conf_water_leakage == 0 ? <img src="/img/gray.png" alt="" className="rms-img-size offline-tr" title="Not Configure" /> : site?.water_leakage == 1 ?
                                                    <div className="alarm_icon   A3">&nbsp;</div>
                                                    :
                                                    <div className="alarm_icon   A1">&nbsp;</div>
                                                }
                                            </td>
                                            <td>
                                                {site?.conf_aviation_light_fault == 0 ? <img src="/img/gray.png" alt="" className="rms-img-size offline-tr" title="Not Configure" /> : site?.aviation_light_fault == 1 ?
                                                    <div className="alarm_icon   A3">&nbsp;</div>
                                                    :
                                                    <div className="alarm_icon   A1">&nbsp;</div>
                                                }
                                            </td>
                                            <td>
                                                {site?.conf_bat_load_fuse_fault == 0 ? <img src="/img/gray.png" alt="" className="rms-img-size offline-tr" title="Not Configure" /> : site?.bat_load_fuse_fault == 1 ?
                                                    <div className="alarm_icon   A3">&nbsp;</div>
                                                    :
                                                    <div className="alarm_icon   A1">&nbsp;</div>
                                                }
                                            </td>
                                            <td>
                                                {site?.phase_fault == 1 ?
                                                    <div className="alarm_icon   A3">&nbsp;</div>
                                                    :
                                                    <div className="alarm_icon   A1">&nbsp;</div>
                                                }
                                            </td>

                                            <td>
                                                {site?.is_overload == 1 ?
                                                    <div className="alarm_icon   A3">&nbsp;</div>
                                                    :
                                                    <div className="alarm_icon   A1">&nbsp;</div>
                                                }
                                            </td>




                                        </tr>
                                    ))}

                                </tbody>
                            </table>

                            {selector?.loading && <div className="text-center">Loading......</div>}
                            {/* <Paginate nextPage={nextPage} previousPage={previousPage} previousPageUrl={selector?.data.prv_page_url} nextPageUrl={selector?.data.next_page_url} postsPerPage={selector?.data.per_page} paginate={paginate} totalPosts={selector?.data.total_page} hasMorePage={selector?.data.has_more_page} onFirstPage={selector?.data.first_page} hasPage={selector?.data.has_page} currentPage={selector?.data.current_page} /> */}

                        </div>
                        <p className="p-0 m-0 fs-12">Current Display 1 - {selector?.sites?.length} Record(s), {selector?.data?.total_page} Record(s) Totally</p>
                    </div>
                </div>
            </div>

        </>
    )
}